export { default } from './fbt-card';
